import { __read, __assign } from 'tslib';
import * as React from 'react';
import { removeEmpty, flattenObject } from './utils/misc.esm.js';

// asPath - The path (including the query) shown in the browser without the configured basePath or locale
var useQueryObject = function (asPath, onRoutePush) {
    var _a;
    var _b = __read(asPath.split('#'), 2), asPathWithoutHashId = _b[0], hashId = _b[1];
    var _c = __read(React.useState(__assign(__assign({}, Object.fromEntries(new URLSearchParams((_a = asPathWithoutHashId.split('?')[1]) !== null && _a !== void 0 ? _a : ''))), { url: '' })), 2), queryObject = _c[0], setQueryObject = _c[1];
    React.useEffect(function () {
        var _a, _b;
        // handle cases if url had query params before. old query will be merged with new one
        var urlQueryParams = Object.fromEntries(new URLSearchParams((_a = asPathWithoutHashId.split('?')[1]) !== null && _a !== void 0 ? _a : ''));
        var newQueryParams = __assign(__assign({}, urlQueryParams), queryObject);
        var queryParams = removeEmpty(flattenObject(newQueryParams));
        var currentPath = (_b = asPathWithoutHashId.split('?')[0]) !== null && _b !== void 0 ? _b : '';
        var queryString = new URLSearchParams(queryParams).toString();
        var queryPath = queryString.length ? "?".concat(queryString) : '';
        var hash = hashId ? "#".concat(hashId) : '';
        var newPath = "".concat(currentPath).concat(queryPath).concat(hash);
        if (newPath !== asPath)
            onRoutePush(newPath, queryParams);
    }, [queryObject]);
    return { queryObject: queryObject, setQueryObject: setQueryObject };
};

export { useQueryObject };
//# sourceMappingURL=useQueryObject.esm.js.map
